import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';

// Guards
import { RedirectGuard } from '@guards/redirect.guard';

// Components
import { PaymentsComponent } from '@components/payments/payments.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';
import { TelemedComponent } from './pages/telemed/telemed.component';
import { SessionComponent } from './session.component';

const routes: Routes = [
  {
    path: '',
    component: SessionComponent,
    data: { title: 'home' },
    canActivateChild: [RedirectGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' } as Route,
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: { title: 'dashboard' },
      },
      {
        path: 'notifications',
        component: NotificationsComponent,
        data: {
          title: 'notifications',
          icon: 'bell',
        },
      },
      {
        path: 'health',
        loadChildren: async () => import('../health/health.module').then((m) => m.HealthModule as any),
        data: {
          title: 'health',
          icon: 'heart',
        },
      },
      {
        path: 'bookings',
        loadChildren: async () => import('../bookings/bookings.module').then((m) => m.BookingsModule as any),
        data: {
          title: 'bookings',
          icon: 'stethoscope',
        },
      },
      {
        path: 'secure-message',
        loadChildren: async () => import('../secure-message/secure-message.module').then((m) => m.SecureMessageModule as any),
        data: {
          title: 'secure_message',
          icon: 'forum-outline',
        },
      },
      {
        path: 'setup',
        loadChildren: async () => import('../setup/setup.module').then((m) => m.SetupModule as any),
        data: {
          title: 'account',
          icon: 'wrench',
        },
      },
      {
        path: 'telemed',
        component: TelemedComponent,
        data: { title: 'telemed', icon: 'message-video' },
      },
      {
        path: 'payments',
        component: PaymentsComponent,
        data: {
          title: 'payments',
          icon: 'credit-card-outline',
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SessionRoutingModule {}
